import { GameState } from '../types';
import { BASE_LEVELS } from '../data/progression';
import { playLevelUpSound } from '../audio';
import { spawnBuildParticles } from '../particles';
import { TILE } from '../constants';

export function getNextLevelCost(state: GameState): number {
  if (state.baseLevel >= 5) return -1; // Max level
  const nextLevel = BASE_LEVELS.find(l => l.level === state.baseLevel + 1);
  return nextLevel ? nextLevel.coinCost : -1;
}

export function getBaseLevelName(level: number): string {
  const def = BASE_LEVELS.find(l => l.level === level);
  return def ? def.name : 'Unknown';
}

export function tryUpgradeBase(state: GameState): boolean {
  const cost = getNextLevelCost(state);
  if (cost < 0) return false;
  if (state.player.coins < cost) return false;

  state.player.coins -= cost;
  state.baseLevel++;

  // Effects
  const cx = state.stationGridX * TILE + TILE / 2;
  const cy = state.stationGridY * TILE + TILE / 2;
  spawnBuildParticles(cx, cy);
  spawnBuildParticles(cx, cy);
  playLevelUpSound();

  // Check win
  if (state.baseLevel >= 5 && !state.hasWon) {
    state.hasWon = true;
    const winModal = document.getElementById('win-modal');
    if (winModal) winModal.classList.remove('hidden');
  }

  return true;
}
